import request from '@/utils/request';

/**
 * 新建联系人
 * @param {*} data
 */
export function crmContactsSaveAPI(data) {
  const url = data.entity && data.entity.contactsId ? 'update' : 'add';
  return request({
    url: 'crmContacts/' + url,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 列表
 * @param {*} data
 */
export function crmContactsIndexAPI(data) {
  return request({
    url: 'crmContacts/queryPageList',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 删除
 * @param {*} data
 */
export function crmContactsDeleteAPI(data) {
  return request({
    url: 'crmContacts/deleteByIds',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 详情
 * @param {*} data
 */
export function crmContactsReadAPI(data) {
  return request({
    url: `crmContacts/queryById/${data.contactsId}`,
    method: 'post',
    data: data
  });
}

/**
 * 联系人转移
 * @param {*} data
 */
export function crmContactsTransferAPI(data) {
  return request({
    url: 'crmContacts/changeOwnerUser',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 联系人下商机
 * @param {*} data
 */
export function crmContactsQueryBusinessAPI(data) {
  return request({
    url: 'crmContacts/queryBusiness',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 联系人导出
 * @param {*} data
 * Contacts_id 联系人ID
 */
export function crmContactsExcelExportAPI(data) {
  return request({
    url: 'crmContacts/batchExportExcel',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    responseType: 'blob'
  });
}

export function crmContactsExcelAllExportAPI(data) {
  return request({
    url: 'crmContacts/allExportExcel',
    method: 'post',
    data: data,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 联系人导入
 * @param {*} data
 *
 */
export function crmContactsExcelImportAPI(data) {
  const param = new FormData();
  Object.keys(data).forEach(key => {
    param.append(key, data[key]);
  });
  return request({
    url: 'crmContacts/uploadExcel',
    method: 'post',
    data: param,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
/**
 * 公海联系人导入
 * @param {*} data
 * contacts_id 联系人ID
 */
export function crmContactsPoolExcelImportAPI(data) {
  const param = new FormData();
  Object.keys(data).forEach(key => {
    param.append(key, data[key]);
  });
  return request({
    url: 'crmContactsPool/uploadExcel',
    method: 'post',
    data: param,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 联系人导入模板下载
 * @param {*} data
 *
 */
export const crmContactsExcelDownloadURL = process.env.VUE_APP_BASE_API + 'crmContacts/downloadExcel';
export function crmContactsDownloadExcelAPI(data) {
  return request({
    url: 'crmContacts/downloadExcel',
    method: 'post',
    data: data,
    responseType: 'blob'
  });
}

/**
 * 公海模板
 * @param {*} data
 * @returns
 */
export function crmContactsPoolDownloadExcelAPI(data) {
  return request({
    url: 'crmContactsPool/downloadExcel',
    method: 'post',
    data: data,
    responseType: 'blob'
  });
}

/**
 * 联系人关联商机
 * @param {*} data
 */
export function crmContactsRelateBusinessAPI(data) {
  return request({
    url: 'crmContacts/relateBusiness',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 联系人取消关联商机
 * @param {*} data
 */
export function crmContactsUnrelateBusinessAPI(data) {
  return request({
    url: 'crmContacts/unrelateBusiness',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 附件列表
 * @param {*} data
 *
 */
export function crmContactsFileListAPI(data) {
  return request({
    url: 'crmContacts/queryFileList',
    method: 'post',
    data: data
  });
}

/**
 * tab数量
 * @param {*} data
 *
 */
export function crmContactsNumAPI(data) {
  return request({
    url: 'crmContacts/num',
    method: 'post',
    data: data
  });
}

/**
 * 标星
 * @param {*} data
 *
 */
export function crmContactsStarAPI(data) {
  return request({
    url: `crmContacts/star/${data.id}`,
    method: 'post'
  });
}

// 团队操作
/**
 * 团队成员创建
 * @param {*} data
 */
export function crmContactsSettingTeamSaveAPI(data) {
  return request({
    url: 'crmContacts/addMembers',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

export function crmContactsSettingTeamDeleteAPI(data) {
  return request({
    url: 'crmContacts/deleteMembers',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

export function crmContactsTeamMembersAPI(data) {
  return request({
    url: `crmContacts/getMembers/${data.id}`,
    method: 'post'
  });
}

export function crmContactsUpdateMembersAPI(data) {
  return request({
    url: 'crmContacts/updateMembers',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 退出团队
 * @param {*} data
 */
export function crmContactsExitTeamAPI(data) {
  return request({
    url: `crmContacts/exitTeam/${data.id}`,
    method: 'post'
  });
}

/**
 * 联系人公海列表
 * @param {*} data
 */
export function crmContactsPoolListAPI(data) {
  return request({
    url: 'crmContactsPool/queryPageList',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 联系人公海全部导出
 * @param {*} data
 */
export function crmContactsPoolExcelAllExport(data) {
  return request({
    url: 'crmContactsPool/allExportExcel',
    method: 'post',
    data: data,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 保存联系人公海外漏高级筛选条件
 * @param {*} data
 */
export function crmContactsPoolSaveSearchExpertAPI(data) {
  return request({
    url: 'crmContactsPool/saveSearchExpert',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 联系人公海字段查询
 * @param {*} data
 */
export function crmContactsPoolQueryPoolFieldAPI(data) {
  return request({
    url: 'crmContactsPool/queryPoolField',
    method: 'post',
    data: data
  });
}

/**
 * 设置锁定字段
 * @param {*} data
 */
export function crmContactsPoolSetIsLockAPI(data) {
  return request({
    url: 'crmContactsPool/setIsLock',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}
/**
 * 联系人管理用到的公海列表
 * @param {*} data
 */
export function crmContactsPoolNameListAPI(data) {
  return request({
    url: 'crmContactsPool/queryPoolNameListByAuth',
    method: 'post',
    data: data
  });
}

/**
 * 获取公海池 操作权限
 * @param {*} data
 */
export function crmContactsPoolQueryAuthAPI(data) {
  return request({
    url: 'crmContactsPool/queryAuthByPoolId',
    method: 'post',
    data: data
  });
}

/**
 * 联系人领取
 * @param {*} data
 */
export function crmContactsReceiveAPI(data) {
  return request({
    url: 'crmContacts/receiveByIds',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 联系人公海导出
 * @param {*} data
 */
export function crmContactsPoolExcelExportAPI(data) {
  return request({
    url: 'crmContactsPool/batchExportExcel',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    responseType: 'blob',
    timeout: 60000
  });
}

/**
 * 删除
 * @param {*} data
 */
export function crmContactsPoolDeleteAPI(data) {
  return request({
    url: 'crmContactsPool/deleteByIds',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// 操作
/**
 * 联系人锁定，解锁
 * @param {*} data
 */
export function crmContactsLockAPI(data) {
  return request({
    url: 'crmContacts/lock',
    method: 'post',
    data: data
  });
}

/**
 * 联系人放入公海
 * @param {*} data
 * contacts_id 	客户数组
 */
export function crmContactsPutInPoolAPI(data) {
  return request({
    url: 'crmContacts/updateContactsByIds',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 设置公海
 * @param {*} data
 */
export function crmContactsPoolSetAPI(data) {
  return request({
    url: 'crmContactsPool/setContactsPool',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 公海设置列表
 * @param {*} data
 */
export function crmContactsPoolSetListAPI(data) {
  return request({
    url: 'crmContactsPool/queryPoolSettingList',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 公海设置删除
 */
export function crmContactsPoolSetDeleteAPI(data) {
  return request({
    url: 'crmContactsPool/deleteContactsPool',
    method: 'post',
    data: data
  });
}

/**
 * 公海设置详情
 * @param {*} data
 */
export function crmContactsPoolSetDetailAPI(data) {
  return request({
    url: 'crmContactsPool/queryPoolById',
    method: 'post',
    data: data
  });
}

/**
 * 公海启停
 * @param {*} data
 */
export function crmContactsPoolSetChangeStatusAPI(data) {
  return request({
    url: 'crmContactsPool/changeStatus',
    method: 'post',
    data: data
  });
}

/**
 * 公海客户转移
 * prePoolId 转出公海id
 * postPoolId 转入公海id
 * @param {*} data
 */
export function crmContactsPoolSetTransferAPI(data) {
  return request({
    url: 'crmContactsPool/transfer',
    method: 'post',
    data: data
  });
}

/**
 * 获取联系人级别选项接口
 * @param {*} data
 */
export function crmContactsPoolQueryLevelAPI(data) {
  return request({
    url: 'crmContactsPool/queryContactsLevel',
    method: 'post',
    data: data
  });
}

/**
 * 转移数据源
 * @param {*} data
 */
export function crmContactsPoolSetNameListAPI(data) {
  return request({
    url: 'crmContactsPool/queryPoolNameList',
    method: 'post',
    data: data
  });
}

/**
 * 联系人分配
 * @param {*} data
 */
export function crmContactsDistributeAPI(data) {
  return request({
    url: 'crmContacts/distributeByIds',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 联系人数据查重
 * @param {*} data
 *
 */
export function crmContactsDataCheckAPI(data) {
  return request({
    url: 'crmContacts/dataCheck',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

